import React from 'react';
import I18n from 'i18n-js';
import { CartBundleFooterApplePayButton } from './CartBundleFooterApplePayButton';
import CheckoutPayPalButton, { isCartEligible } from './CheckoutPayPalButton';
import { CheckoutErrorAlertBox } from './checkout/CheckoutErrorAlertBox';
import {
  core_apimessages_Money as Money,
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
} from '../../src/schemas/rql';
import { useExpEnabled, useUser } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';
import { inMobileBrowser } from '@reverbdotcom/commons/src/user_context_helpers';
import { useApplePayAvailabilityByConfig } from './useApplePayAvailability';

interface Props {
  paymentMethodType: CheckoutPaymentMethodType;
  currency: string;
  checkoutBundlingId: string;
  applePayCheckoutBundlingId: string;
  amountTotal: Money;
  adyenCheckoutPaymentMethodsConfig: string;
  paypalCheckoutExpAttributes: {
    currencyCount: number,
    bundleCount: number,
    isLocalPickupOnly: boolean,
    includesStandalonePaypal: boolean,
  }
}

export default function CartFooterExpressPayWrapper(props: Props) {
  const user = useUser();
  const [errors, setErrors] = React.useState([]);

  const isDirectCheckout = props.paymentMethodType === CheckoutPaymentMethodType.DIRECT_CHECKOUT;
  const [isApplePayAvailable] = useApplePayAvailabilityByConfig(props.adyenCheckoutPaymentMethodsConfig);
  const showApplePayButton = isApplePayAvailable && isDirectCheckout;

  const inPaypalButtonRollout = useExpEnabled(experiments.PAYPAL_CHECKOUT_BUTTON);
  const showPaypalButton = inPaypalButtonRollout && isCartEligible(props.paypalCheckoutExpAttributes);

  const showExpressPay = inPaypalButtonRollout && !inMobileBrowser(user) && showApplePayButton && showPaypalButton;

  if (!showExpressPay) {
    return null;
  }

  return (
    <>
      {errors.length > 0 &&
        <div className="mtb-2">
          <CheckoutErrorAlertBox errors={errors} />
        </div>
      }
      <div className="cart-footer-express-pay-wrapper">
        <div className="weight-bold fx-align-self-center ml-1">{I18n.t('discovery.checkout.expressCheckout.title')}</div>
        <div className="d-flex mr-2">
          <div className="checkout-cart-footer__button checkout-cart-footer__button--paypal">
            {showPaypalButton &&
              <CheckoutPayPalButton
                currency={props.amountTotal.currency}
                checkoutBundlingId={props.checkoutBundlingId}
                onError={setErrors}
                variant="cart"
                parentComponentName="CartFooterExpressPayWrapper"
              />
            }
          </div>
          <div className="ml-1">
            {isDirectCheckout &&
              <CartBundleFooterApplePayButton
                checkoutBundlingId={props.applePayCheckoutBundlingId}
                amountTotal={props.amountTotal}
                adyenCheckoutPaymentMethodsConfig={props.adyenCheckoutPaymentMethodsConfig}
              />
            }
          </div>
        </div>
      </div>
    </>
  );
}
